import { Dialog } from "@chakra-ui/react"

// A wrapper around the Chakra Dialog component
// Useful for import into the legacy client
// TODO: Add header and footer

interface ModalProps {
  children: React.ReactNode
  open: boolean
  onOpenChange: (details: { open: boolean }) => void
  modalProps: Dialog.RootProps
  contentProps: Dialog.ContentProps
  overlayProps: Dialog.BackdropProps
  positionerProps?: Dialog.PositionerProps
  bodyProps: Dialog.BodyProps
  closeProps: Dialog.CloseTriggerProps
  showCloseButton?: boolean
}

const ChakraModal = ({
  children,
  showCloseButton = true,
  modalProps,
  contentProps,
  overlayProps,
  positionerProps,
  bodyProps,
  closeProps
}: ModalProps) => {
  return (
    <Dialog.Root {...modalProps}>
      <Dialog.Backdrop {...overlayProps} />
      <Dialog.Positioner {...positionerProps}>
        <Dialog.Content {...contentProps} className="ChakraModalContent">
          {showCloseButton && <Dialog.CloseTrigger {...closeProps} />}
          <Dialog.Body {...bodyProps}>{children}</Dialog.Body>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  )
}

// Mainly to silence console warnings when using ChakraModal with legacy ConnectStore.
ChakraModal.displayName = "ChakraModal"

export default ChakraModal
